import IntegrazioneBusinessList from "./components/IntegrazioneBusinessList.vue";
import IntegrazioneBusinessView from "./components/IntegrazioneBusinessView.vue";

export default {
  IntegrazioneBusinessList,
  IntegrazioneBusinessView
};
